\<template>
    <div class="table-responsive" style="height:75vh" >
        <table
            class="table table-bordered boq-line-items-table"
            :class="{'boq-line-items-table--published': IsQuotationPublished}"
        >
            <thead class="sticky-top">
                <tr >
                    <!-- Checkbox header cell -->
                    <th v-if="!IsQuotationPublished" class="sticky-left boq-col-select text-center align-middle d-print-none"><input
                         type="checkbox"
                         v-model="inDeleteBulk"
                        @change="toggleAll($event.target.checked)"/>
                    </th>
                    <th valign="middle" class="sticky-left boq-col-serial text-center">{{ $t('S/N') }}</th>
                    <th valign="middle" class="sticky-left boq-col-description">{{ $t('Description') }}</th>
                    <th v-if="boqId" valign="middle" class="boq-col-image text-center">{{ $t('Image') }}</th>
                    <th class="boq-col-space-id" valign="middle">{{ $t('Space ID') }}</th>
                    <th style="min-width:70px;" valign="middle">{{ $t('Unit') }}</th>
                    <BoqLineItemRowThead 
                    :selectedColumns="selectedColumns" />
                    <th v-if="hasActionColumn" class="sticky-right text-center d-print-none">{{ $t('Actions') }}</th>
                </tr>
            </thead>
               <tbody class="table-group-divider"  v-if="rowDatas.length==0">
                 <tr>
                    <td 
                     :colspan="tableColspan">{{ $t('No data Found') }}
                    </td>
                </tr>
                </tbody>
                <Draggable itemKey="_id" v-model="LineItemData" tag="tbody" v-else
                :animation="150" ghostClass="opacity-50" handle=".handle" :onEnd="onEndDrag" >
                    <template #item="{element}" >
                        <tr  >
                            <td class="sticky-left boq-col-select bg-white text-center handle d-print-none" v-if="!IsQuotationPublished"><i class="fa-solid fa-up-down-left-right"></i></td>
                            <td class="sticky-left boq-col-serial bg-white text-center">
                                {{element.label}}
                            </td>
                            <td class="sticky-left boq-col-description bg-white" @click="onCellClick(element._id)" role="button">
                                <div   >
                                    <div class="d-flex justify-content-between">
                                        <small class="fw-bold text-capitalize"><input class="d-print-none" type="checkbox" v-if="!IsQuotationPublished && !element.forProcurement" v-model="toBeMoved" :value="element._id" @change="onRowChange" @click.stop /> 
                                            <span class="fw-bold text-capitalize" v-if="userInfo.language=='en'">{{element.name}}</span>
                                            <span class="fw-bold" v-else>{{element.nameCh || element.name}}</span>
                                        </small> 
                                        <span>
                                            <small v-if="element.remark" class="text-info me-1 bg-light px-1 rounded">{{ $t('BillOfQuantityRemark.' + element.remark) }}</small>
                                            <small v-if="element.rateOnly" class="text-danger bg-light px-1 rounded">{{$t('RATE ONLY')}}</small>
                                            <small v-if="element.forProcurement" class="text-success bg-light px-1 rounded">{{$t('Bill of Quantity Module.For Procurement')}}</small>
                                        </span>
                                    </div>
                                    <div>
                                    </div>
                                    <p class="small mb-0 description-line-item ps-3">
                                        {{element.description}}
                                    </p>
                                </div>
                            </td>
                            <td v-if="boqId" class="boq-col-image text-center align-middle">
                                <div v-if="imageSummaryStates[element._id] === 'loading'" class="boq-image-cell-status text-muted d-print-none" role="status">
                                    <span class="spinner-border spinner-border-sm" aria-hidden="true"></span>
                                    <small class="d-block mt-2">{{ $t('Loading images') }}</small>
                                </div>
                                <div v-else-if="imageSummaryStates[element._id] === 'error'" class="boq-image-cell-error d-print-none">
                                    <div class="boq-image-unavailable">
                                        <div class="boq-image-unavailable-heading">
                                            <i class="fa-regular fa-image boq-image-unavailable-icon" aria-hidden="true"></i>
                                            <p class="boq-image-unavailable-text">{{ $t('Image preview unavailable') }}</p>
                                        </div>
                                        <button type="button" class="boq-image-retry" :aria-label="$t('Retry image preview') + ': ' + element.name" @click="RefreshImageSummary(element._id)">
                                            <i class="fa-solid fa-arrow-rotate-right" aria-hidden="true"></i>
                                            <span>{{ $t('Retry') }}</span>
                                        </button>
                                    </div>
                                    <button type="button" class="boq-image-cell-link" :aria-label="$t('Manage images') + ': ' + element.name" @click="OpenImages(element, $event)">{{ $t('Manage images') }}</button>
                                </div>
                                <span v-if="(!canManageImages || isItemProcured(element)) && !imageSummaries[element._id]?.count" class="boq-image-cell-button boq-image-cell-button--disabled" :title="$t('No image attached')" :aria-label="$t('No image attached')" aria-disabled="true">
                                    <i class="fa-regular fa-images" aria-hidden="true"></i>
                                    <small class="d-block mt-1">{{ $t('No image') }}</small>
                                </span>
                                <button v-else type="button" class="boq-image-cell-button" :title="$t('Images') + ': ' + element.name" :aria-label="$t('Images') + ': ' + element.name" @click="OpenImages(element, $event)">
                                    <template v-if="imageSummaries[element._id]?.image">
                                        <span class="boq-image-cell-frame">
                                            <span v-if="!loadedSummaryPreviews[element._id]" class="boq-image-cell-loading" role="status"><span class="spinner-border spinner-border-sm" aria-hidden="true"></span><span class="visually-hidden">{{ $t('Loading image') }}</span></span>
                                            <BoqItemImage class="boq-image-cell-preview" :class="{'boq-image-cell-preview--loading': !loadedSummaryPreviews[element._id]}" :boqId="boqId" :itemId="element._id" :image="imageSummaries[element._id].image" :imageContextType="imageContextType || 'boq'" :alt="imageSummaries[element._id].image.originalFilename || element.name" @load="ImagePreviewLoaded(element._id, $event)" @error="ImagePreviewFailed(element._id, $event)" />
                                        </span>
                                        <small v-if="imageSummaries[element._id].count > 1" class="d-block mt-1 d-print-none">{{ imageSummaries[element._id].count }} {{ $t('images') }}</small>
                                    </template>
                                    <span v-else class="d-print-none">
                                        <i :class="canManageImages && !isItemProcured(element) ? 'fa-solid fa-plus' : 'fa-regular fa-images'" aria-hidden="true"></i>
                                        <small class="d-block mt-1">{{ ImageCellLabel(element) }}</small>
                                    </span>
                                </button>
                            </td>
                            <td class="boq-col-space-id">{{element.area}}</td>
                            <td>{{element.unit}}</td>
                            <BoqLineItemRow 
                            :data="element" :ReformatNumber="ReformatNumber" :selectedColumns="selectedColumns" />
                            <td v-if="hasActionColumn" style="width : 50px" class="boq-preliminaries-action-cell sticky-right bg-white shadow-lg d-print-none"  >
                                <div>
                                    <button class="btn btn-outline-primary btn-action mb-1" @click="OpenEditModal(element)"
                                    ref="ModalUpdateLineItemBtn"
                                    v-if="canEditLineItem && !isItemProcured(element)"
                                    data-bs-toggle="modal" data-bs-target="#ModalUpdateLineItem"
                                    >
                                        <i class="fa-solid fa-edit"></i>
                                    </button>
                            
                                    <button v-if="canRemoveLineItem && !element.forProcurement" class="btn btn-outline-warning btn-action me-1" 
                                        @click="OpenDelete(element._id)" > <i class="fa-solid fa-trash-can"></i> </button> 
                                </div>
                            </td>
                        </tr>
                    </template>
                </Draggable>
                <tfoot>
                    <tr class="bg-light-primary fw-bold sticky-bottom">
                        <td v-if="!IsQuotationPublished" class="sticky-left boq-col-select bg-light-primary d-print-none"></td>
                        <td class="sticky-left boq-col-serial bg-light-primary"></td>
                        <td class="sticky-left boq-col-description bg-light-primary">{{ $t('Totals') }}</td>
                        <td v-if="boqId" class="boq-col-image bg-light-primary"></td>
                        <td class="boq-col-space-id"></td>
                        <td style="min-width:70px;"></td>
                        <BoqLineItemRowFooter 
                            :data="totalObj" :ReformatNumber="ReformatNumber" :selectedColumns="selectedColumns" />
                        <td v-if="hasActionColumn" class="boq-preliminaries-action-cell d-print-none"></td>
                    </tr>
               </tfoot>
        </table>
        <BoqItemImagesModal v-if="imageItem && boqId" :boqId="boqId" :item="imageItem" :imageContextType="imageContextType || 'boq'" :allowEdit="canManageImages && !isItemProcured(imageItem)" @close="CloseImages" @images-changed="UpdateImageSummary" />
    </div>
    
</template>
<style scoped>
.handle{
    cursor: move;
}
.boq-col-space-id {
    width: 80px;
    min-width: 80px;
    max-width: 80px;
}
:deep(.boq-col-markup) {
    width: 85px;
    min-width: 85px;
    max-width: 85px;
    white-space: nowrap;
}
td.boq-col-space-id {
    white-space: normal;
    overflow-wrap: anywhere;
}
.boq-col-image { width: 160px; min-width: 160px; }
.boq-col-image button { border-radius: 0; }
.boq-image-cell-button { min-width: 132px; min-height: 96px; padding: 0; overflow: hidden; border: 1px solid #d5deea; border-radius: 0; background: #f8fafc; color: #315581; }
.boq-image-cell-button:hover { background: #edf3fa; border-color: #315581; }
.boq-image-cell-button:focus-visible { outline: 2px solid #315581; outline-offset: 2px; }
.boq-image-cell-button--disabled { display: inline-flex; width: 132px; height: 96px; align-items: center; justify-content: center; flex-direction: column; cursor: default; }
.boq-image-cell-button--disabled:hover { background: #f8fafc; border-color: #d5deea; }
.boq-image-cell-frame { display: block; position: relative; width: 132px; height: 96px; background: #fff; }
.boq-image-cell-preview { display: block; width: 132px; height: 96px; object-fit: cover; object-position: top; }
.boq-image-cell-preview--loading { opacity: 0; }
.boq-image-cell-loading { position: absolute; inset: 0; display: flex; align-items: center; justify-content: center; background: #f1f5f9; }
.boq-image-cell-status { min-width: 132px; min-height: 96px; padding: 12px 4px; }
.boq-image-cell-error { width: 112px; margin: 0 auto; }
.boq-image-unavailable { display: flex; flex-direction: column; align-items: center; gap: 6px; padding: 8px; border: 1px solid #e0e4e8; background: #f8f9fa; }
.boq-image-unavailable-heading { display: flex; align-items: center; gap: 6px; width: 100%; text-align: left; }
.boq-image-unavailable-icon { flex: 0 0 16px; color: #77828e; font-size: 16px; line-height: 1; }
.boq-image-unavailable-text { margin: 0; color: #586573; font-size: 11px; line-height: 1.35; }
.boq-image-retry { display: inline-flex; align-items: center; justify-content: center; gap: 5px; min-width: 70px; min-height: 26px; padding: 4px 8px; border: 1px solid #e5c6b2; background: #fff3eb; color: #9a3d0b; font: inherit; font-size: 11px; font-weight: 600; line-height: 1.4; cursor: pointer; transition: background-color 0.15s, border-color 0.15s; }
.boq-image-retry:hover { border-color: #ca5015; background: #ffe7d7; }
.boq-image-retry:active { background: #ffdcc4; }
.boq-image-cell-link { display: block; min-height: 24px; margin: 2px auto 0; padding: 4px 2px; border: 0; background: none; color: #586573; font: inherit; font-size: 11px; line-height: 1.4; cursor: pointer; text-decoration: underline; text-decoration-color: #b2bbc4; text-underline-offset: 3px; }
.boq-image-cell-link:hover { color: #9a3d0b; text-decoration-color: currentColor; }
.boq-image-retry:focus-visible, .boq-image-cell-link:focus-visible { outline: 2px solid #ca5015; outline-offset: 2px; }
@media print { .boq-image-cell-button { border: 0; background: transparent; padding: 0; } }
</style>

<script>
import {GetBoqItemDelete} from '@/actions/boqActions.js'
import {GetBoqImageSummaries} from '@/actions/boqImageActions.js'
import { ApprovalStageBoq, ReformatNumber, ModuleActionList, BoQColumnList, LineItemRemarks} from '@/helpers/utilities.js'
import { mapGetters } from 'vuex'
import BoqLineItemRow from '@/components/boq/BoqLineItemRow.vue'
import BoqLineItemRowThead from '@/components/boq/BoqLineItemRowThead.vue'
import BoqLineItemRowFooter from '@/components/boq/BoqLineItemRowFooter.vue'
import Draggable from 'vuedraggable'
import BoqItemImagesModal from '@/components/boq/BoqItemImagesModal.vue'
import BoqItemImage from '@/components/boq/BoqItemImage.vue'
export default {
    name : 'BoqItemTableBreakdown',
    props : ['rowDatas', 'OpenEditModal','UpdateEdited','selectedColumns','selectedRows', 'GetSequence', 'IsQuotationPublished'
    ,'updateSelected', 'reloadData', 'BoqCategoryList', 'GetChanges','customPermission','DeleteItemFunc','SyncSelectedLineItem', 'boqId', 'sections', 'imageContextType', 'canEditImages'],
    data(){
        return {
            ApprovalStageBoq : ApprovalStageBoq,
            ModuleActionList : ModuleActionList,
            selectedLineItems : [],
            selectedLineItemsId : [],
            LineItemData : [],
            permissionList : [],
            dataReady :false,
            toBeMoved : [],
            totalObj : {},
            inDeleteBulk: false, 
            imageItem: null,
            imageSummaries: {},
            imageSummaryStates: {},
            imageSummaryVersions: {},
            loadedSummaryPreviews: {},
            refreshedSummaryPreviews: {},
            imageSummaryRequest: 0,
            LineItemRemarks
        }
    },
    components : {
        BoqLineItemRow,BoqLineItemRowThead, Draggable, BoqLineItemRowFooter, BoqItemImagesModal, BoqItemImage
    },
    mounted : async function(){

        if(this.customPermission){
            this.permissionList = this.customPermission
        }
        else{
            this.permissionList = this.permission
        }
        this.ReformatRows()


    },
    watch : {
        imageRowsKey: {
            immediate: true,
            handler() { this.LoadImageSummaries() }
        },
        permission(val){
            if(!this.customPermission){
                this.permissionList = val
            }
        },
    },
    computed : {
        ...mapGetters(['permission','userInfo']),
        imageRowsKey() {
            return `${this.boqId || ''}:${(this.rowDatas || []).map(item => item._id).join(',')}`
        },
        canEditLineItem(){
        console.log(this.IsQuotationPublished , this.permissionList.indexOf(ModuleActionList.BOQ_EDIT) > -1)
            return !this.IsQuotationPublished && this.permissionList.indexOf(ModuleActionList.BOQ_EDIT) > -1
        },
        canManageImages(){
            return this.canEditLineItem && this.canEditImages !== false
        },
        canRemoveLineItem(){
            return !this.IsQuotationPublished && this.permissionList.indexOf(ModuleActionList.BOQ_ITEM_REMOVE) > -1
        },
        hasActionColumn(){
            return this.canEditLineItem || this.canRemoveLineItem
        },
        tableColspan(){
            const fixedColumns = (this.IsQuotationPublished ? 0 : 1) + 4 + (this.boqId ? 1 : 0)
            const selectedColumnCount = Array.isArray(this.selectedColumns) ? this.selectedColumns.length : 0
            return fixedColumns + selectedColumnCount + (this.hasActionColumn ? 1 : 0)
        },
        CostCodeList(){
            const self = this 
            if(self.rowDatas.length==0){
                 return []
             }
      
            let mainCateg = { costCodeId : '' }
            let subCateg = { costCodeId : '' }
      
            let fieldListMain = {
                 costTotal : 0,
                 supplyTotal : 0,
                 installTotal : 0,
                 costTotalBuffer : 0,
                 supplyAndInstallTotal : 0,
                 costTotalTotal : 0,
                 sellTotal : 0,
                 sellTotalBuffer : 0,
                 sellTotalTotal : 0,
                 gp : 0,
                 gpBuffer : 0,
                 gpTotal : 0,
                 index : 0
             }
      
             let fieldListSub = {
                 costTotal : 0,
                 supplyTotal : 0,
                 installTotal : 0,
                 costTotalBuffer : 0,
                 supplyAndInstallTotal : 0,
                 costTotalTotal : 0,
                 sellTotal : 0,
                 sellTotalBuffer : 0,
                 sellTotalTotal : 0,
                 gp : 0,
                 gpBuffer : 0,
                 gpTotal : 0,
                 index : 0
             }
      
             let totalList= []
             let totalListSub= []
             let parentLetter = 65
             let subCount = 1
             let lineItemSubCount = 1
      
            const arrayLength = self.rowDatas.length
            let ReformatData = self.rowDatas.map((u,index)=>{
                 let showMainCateg = false
                 let showSubCatag = false
                 const nextLineItem = self.rowDatas[index + 1]
                 const supplyAndInstallCombine = u.supplyAndInstall ? u.supplyAndInstall : (u.costRate || 0) + (u.installRate || 0)
                 const  supplyAndInstallTotal = supplyAndInstallCombine * u.quantity
                 //main category sum 
                 fieldListMain.costTotal += u.costTotalRaw
                 fieldListMain.supplyTotal += u.supplyTotal
                 fieldListMain.installTotal += u.installTotal
                 fieldListMain.costTotalBuffer += u.costTotal - u.costTotalRaw
                 fieldListMain.supplyAndInstallTotal += supplyAndInstallTotal
                 fieldListMain.costTotalTotal += u.costTotal
                 fieldListMain.sellTotal += u.sellTotalRaw
                 fieldListMain.sellTotalBuffer += u.sellTotal - u.sellTotalRaw
                 fieldListMain.sellTotalTotal += u.sellTotal
                 fieldListMain.gp += u.gpRaw
                 fieldListMain.gpBuffer +=  u.gp - u.gpRaw
                 fieldListMain.gpTotal += u.gp
                 
                 //sub category sum
                 fieldListSub.costTotal += u.costTotalRaw
                 fieldListSub.supplyTotal += u.supplyTotal
                 fieldListSub.installTotal += u.installTotal
                 fieldListSub.costTotalBuffer += u.costTotal - u.costTotalRaw
                 fieldListSub.supplyAndInstallTotal += supplyAndInstallTotal
                 fieldListSub.costTotalTotal += u.costTotal
                 fieldListSub.sellTotal += u.sellTotalRaw
                 fieldListSub.sellTotalBuffer += u.sellTotal - u.sellTotalRaw
                 fieldListSub.sellTotalTotal += u.sellTotal
                 fieldListSub.gp += u.gpRaw
                 fieldListSub.gpBuffer +=  u.gp - u.gpRaw
                 fieldListSub.gpTotal += u.gp
      
      
                 if(u.parents[0].costCodeId!=mainCateg.costCodeId){
                     showMainCateg = true
                     mainCateg = u.parents[0]
                     mainCateg.label = String.fromCharCode(parentLetter)
                     ++parentLetter
                     subCount = 1
                     fieldListMain.index = index
                 }
             
                 if(u.parents[1].costCodeId!=subCateg.costCodeId){
                     showSubCatag = true
                     subCateg = u.parents[1]
                     subCateg.label = mainCateg.label + subCount
                     ++subCount
                     lineItemSubCount = 1
                     fieldListSub.index = index
                 }
                 u.label = subCateg.label +'.'+ lineItemSubCount
                 ++lineItemSubCount
                 u.bufferCostTotal = u.costTotal - u.costTotalRaw
                 u.bufferSellRate = u.sellRate - u.sellRateRaw
                 u.bufferSellTotal = u.sellTotal - u.sellTotalRaw
                 u.bufferGp = u.gp - u.gpRaw
                 u.supplyAndInstallTotal = supplyAndInstallTotal
             
                 //main category
                 if(index + 1==arrayLength){
                    totalList.push({
                        costTotal : fieldListMain.costTotal ,
                        supplyTotal : fieldListMain.supplyTotal ,
                        installTotal : fieldListMain.installTotal ,
                        costTotalBuffer : fieldListMain.costTotalBuffer,
                        supplyAndInstallTotal : fieldListMain.supplyAndInstallTotal,
                        costTotalTotal : fieldListMain.costTotalTotal ,
                        sellTotal : fieldListMain.sellTotal  ,
                        sellTotalBuffer : fieldListMain.sellTotalBuffer ,
                        sellTotalTotal : fieldListMain.sellTotalTotal ,
                        gp : fieldListMain.gp ,
                        gpBuffer : fieldListMain.gpBuffer ,
                        gpTotal : fieldListMain.gpTotal ,
                        index : fieldListMain.index,
                    })
                }else if(u.parents[0].costCodeId!=nextLineItem.parents[0].costCodeId){
                    totalList.push({
                        costTotal : fieldListMain.costTotal ,
                        supplyTotal : fieldListMain.supplyTotal ,
                        installTotal : fieldListMain.installTotal ,
                        costTotalBuffer : fieldListMain.costTotalBuffer,
                        supplyAndInstallTotal : fieldListMain.supplyAndInstallTotal,
                        costTotalTotal : fieldListMain.costTotalTotal ,
                        sellTotal : fieldListMain.sellTotal  ,
                        sellTotalBuffer : fieldListMain.sellTotalBuffer ,
                        sellTotalTotal : fieldListMain.sellTotalTotal ,
                        gp : fieldListMain.gp ,
                        gpBuffer : fieldListMain.gpBuffer ,
                        gpTotal : fieldListMain.gpTotal ,
                        index : fieldListMain.index,
                    })
 
                    fieldListMain = {
                        costTotal : 0 ,
                        supplyTotal : 0 ,
                        installTotal : 0,
                        costTotalBuffer : 0,
                        supplyAndInstallTotal : 0,
                        costTotalTotal : 0,
                        sellTotal : 0  ,
                        sellTotalBuffer : 0,
                        sellTotalTotal : 0 ,
                        gp : 0 ,
                        gpBuffer : 0 ,
                        gpTotal : 0 ,
                        index : 0,
                    }
                }
                //sub category
                if(index + 1==arrayLength){
                    totalListSub.push({
                        costTotal : fieldListSub.costTotal ,
                        supplyTotal : fieldListSub.supplyTotal ,
                        installTotal : fieldListSub.installTotal ,
                        costTotalBuffer : fieldListSub.costTotalBuffer,
                        supplyAndInstallTotal : fieldListSub.supplyAndInstallTotal,
                        costTotalTotal : fieldListSub.costTotalTotal ,
                        sellTotal : fieldListSub.sellTotal  ,
                        sellTotalBuffer : fieldListSub.sellTotalBuffer ,
                        sellTotalTotal : fieldListSub.sellTotalTotal ,
                        gp : fieldListSub.gp ,
                        gpBuffer : fieldListSub.gpBuffer ,
                        gpTotal : fieldListSub.gpTotal ,
                        index : fieldListSub.index,
                    })
                }else if(u.parents[1].costCodeId!=nextLineItem.parents[1].costCodeId){
                    totalListSub.push({
                        costTotal : fieldListSub.costTotal ,
                        supplyTotal : fieldListSub.supplyTotal ,
                        installTotal : fieldListSub.installTotal ,
                        costTotalBuffer : fieldListSub.costTotalBuffer,
                        supplyAndInstallTotal : fieldListSub.supplyAndInstallTotal,
                        costTotalTotal : fieldListSub.costTotalTotal ,
                        sellTotal : fieldListSub.sellTotal  ,
                        sellTotalBuffer : fieldListSub.sellTotalBuffer ,
                        sellTotalTotal : fieldListSub.sellTotalTotal ,
                        gp : fieldListSub.gp ,
                        gpBuffer : fieldListSub.gpBuffer ,
                        gpTotal : fieldListSub.gpTotal ,
                        index : fieldListSub.index,
                    })
 
                    fieldListSub = {
                        costTotal : 0 ,
                        supplyTotal : 0 ,
                        installTotal : 0,
                        costTotalBuffer : 0,
                        supplyAndInstallTotal : 0,
                        costTotalTotal : 0,
                        sellTotal : 0  ,
                        sellTotalBuffer : 0,
                        sellTotalTotal : 0 ,
                        gp : 0 ,
                        gpBuffer : 0 ,
                        gpTotal : 0 ,
                        index : 0,
                    }
                }
             
                 return {
                    _id : u._id,
                     lineItem : u,
                     mainCateg : showMainCateg ? mainCateg : null,
                     subCateg : showSubCatag ? subCateg : null
                 }
            })
            //loop main totals
            for(let x=0;x<totalList.length;x++){
                 const data = totalList[x]
                 ReformatData[data.index].mainCateg.totals = {}
                 ReformatData[data.index].mainCateg.totals.costTotal = data.costTotal 
                 ReformatData[data.index].mainCateg.totals.supplyTotal = data.supplyTotal 
                 ReformatData[data.index].mainCateg.totals.installTotal= data.installTotal 
                 ReformatData[data.index].mainCateg.totals.costTotalBuffer = data.costTotalBuffer
                 ReformatData[data.index].mainCateg.totals.supplyAndInstallTotal = data.supplyAndInstallTotal
                 ReformatData[data.index].mainCateg.totals.costTotalTotal = data.costTotalTotal 
                 ReformatData[data.index].mainCateg.totals.sellTotal = data.sellTotal  
                 ReformatData[data.index].mainCateg.totals.sellTotalBuffer = data.sellTotalBuffer 
                 ReformatData[data.index].mainCateg.totals.sellTotalTotal = data.sellTotalTotal 
                 ReformatData[data.index].mainCateg.totals.gp =data.gp 
                 ReformatData[data.index].mainCateg.totals.gpBuffer = data.gpBuffer 
                 ReformatData[data.index].mainCateg.totals.gpTotal = data.gpTotal 
            }
            for(let x=0;x<totalListSub.length;x++){
                 const data = totalListSub[x]
                 ReformatData[data.index].subCateg.totals = {}
                 ReformatData[data.index].subCateg.totals.costTotal = data.costTotal 
                 ReformatData[data.index].subCateg.totals.supplyTotal = data.supplyTotal 
                 ReformatData[data.index].subCateg.totals.installTotal= data.installTotal 
                 ReformatData[data.index].subCateg.totals.costTotalBuffer = data.costTotalBuffer
                 ReformatData[data.index].subCateg.totals.supplyAndInstallTotal = data.supplyAndInstallTotal
                 ReformatData[data.index].subCateg.totals.costTotalTotal = data.costTotalTotal 
                 ReformatData[data.index].subCateg.totals.sellTotal = data.sellTotal  
                 ReformatData[data.index].subCateg.totals.sellTotalBuffer = data.sellTotalBuffer 
                 ReformatData[data.index].subCateg.totals.sellTotalTotal = data.sellTotalTotal 
                 ReformatData[data.index].subCateg.totals.gp =data.gp 
                 ReformatData[data.index].subCateg.totals.gpBuffer = data.gpBuffer 
                 ReformatData[data.index].subCateg.totals.gpTotal = data.gpTotal 
             }
      
            return ReformatData
        }
    },
    methods : {
    async LoadImageSummaries() {
        const request = ++this.imageSummaryRequest
        this.imageSummaries = {}
        this.imageSummaryStates = {}
        this.imageSummaryVersions = {}
        this.loadedSummaryPreviews = {}
        this.refreshedSummaryPreviews = {}
        if (!this.boqId) return
        const itemIds = [...new Set((this.rowDatas || []).map(item => item._id).filter(Boolean))]
        const versions = Object.fromEntries(itemIds.map(id => [id, 0]))
        itemIds.forEach(id => { this.imageSummaryStates[id] = 'loading' })
        for (let offset = 0; offset < itemIds.length; offset += 100) {
            const batch = itemIds.slice(offset, offset + 100)
            try {
                const result = await GetBoqImageSummaries(this.boqId, batch, this.imageContextType || 'boq')
                if (request !== this.imageSummaryRequest) return
                // Keep any newer changes made through the dialog while this batch was loading.
                batch.forEach(id => {
                    if ((this.imageSummaryVersions[id] || 0) !== versions[id]) return
                    this.ApplyImageSummary(id, result.items?.[id])
                })
            } catch {
                if (request !== this.imageSummaryRequest) return
                batch.forEach(id => {
                    if ((this.imageSummaryVersions[id] || 0) === versions[id]) this.imageSummaryStates[id] = 'error'
                })
            }
        }
    },
    ApplyImageSummary(itemId, summary) {
        const sameImage = summary?.image?.url && summary.image.url === this.imageSummaries[itemId]?.image?.url
        const alreadyLoaded = Boolean(sameImage && this.loadedSummaryPreviews[itemId])
        this.imageSummaryStates[itemId] = summary ? 'ready' : 'error'
        this.loadedSummaryPreviews[itemId] = alreadyLoaded
        if (summary) this.imageSummaries[itemId] = summary
    },
    async RefreshImageSummary(itemId) {
        if (this.imageSummaryStates[itemId] === 'loading' || !this.boqId) return
        const request = this.imageSummaryRequest
        const version = (this.imageSummaryVersions[itemId] || 0) + 1
        this.imageSummaryVersions[itemId] = version
        this.imageSummaryStates[itemId] = 'loading'
        this.loadedSummaryPreviews[itemId] = false
        try {
            const result = await GetBoqImageSummaries(this.boqId, [itemId], this.imageContextType || 'boq')
            if (request !== this.imageSummaryRequest || version !== this.imageSummaryVersions[itemId]) return
            this.ApplyImageSummary(itemId, result.items?.[itemId])
        } catch {
            if (request !== this.imageSummaryRequest || version !== this.imageSummaryVersions[itemId]) return
            this.imageSummaryStates[itemId] = 'error'
        }
    },
    ImagePreviewLoaded(itemId, event) {
        if (event.url !== this.imageSummaries[itemId]?.image?.url) return
        this.loadedSummaryPreviews[itemId] = true
    },
    ImagePreviewFailed(itemId, event) {
        if (event.url !== this.imageSummaries[itemId]?.image?.url) return
        this.loadedSummaryPreviews[itemId] = false
        if (this.refreshedSummaryPreviews[itemId]) {
            this.imageSummaryStates[itemId] = 'error'
            return
        }
        this.refreshedSummaryPreviews[itemId] = true
        return this.RefreshImageSummary(itemId)
    },
    ImageCellLabel(item) {
        const summary = this.imageSummaries[item._id]
        if (!summary) return this.$t('Loading images')
        return this.canManageImages && !this.isItemProcured(item) ? this.$t('Add image') : this.$t('No image')
        },
        isItemProcured(item) {
            if (item?.forProcurement) return true
            const sectionId = item?.boqSequenceParentId
            return Boolean(sectionId && (this.sections || []).some(section => String(section._id) === String(sectionId) && section.forProcurement))
    },
    UpdateImageSummary({ itemId, image, count }) {
        this.imageSummaryVersions[itemId] = (this.imageSummaryVersions[itemId] || 0) + 1
        this.ApplyImageSummary(itemId, { image, count })
        this.refreshedSummaryPreviews[itemId] = false
    },
    OpenImages(item, event) {
        // Read-only line items with no images have nothing to display.
        if (!this.canManageImages && !this.imageSummaries[item._id]?.count) return
        this.imageTrigger = event.currentTarget
        this.imageItem = item
    },
    CloseImages() {
        this.imageItem = null
        this.$nextTick(() => this.imageTrigger?.focus())
    },
    onCellClick(id) {
    // Ignore cell clicks during bulk delete mode
    if (this.inDeleteBulk) return;
    this.AddItemToMovables(id);
  },
  toggleRowSelection(id) {
    const i = this.selectedLineItems.indexOf(id)
    if (i === -1) this.selectedLineItems.push(id)
    else this.selectedLineItems.splice(i, 1)
  },
  toggleAll(checked) {
  this.inDeleteBulk = checked;
  if (checked) {
    this.toBeMoved = this.rowDatas.map(r => r._id);
    // keep parent in sync for the delete modal count
    this.SyncSelectedLineItem(this.toBeMoved);
  } else {
    this.toBeMoved = [];
    this.SyncSelectedLineItem([]);
  }
},

  onRowChange() {
    if (this.inDeleteBulk) return;          // never trigger move in bulk mode
    this.SyncSelectedLineItem(this.toBeMoved);
  },

  AddItemToMovables(id) {
    const i = this.toBeMoved.indexOf(id);
    if (i === -1) this.toBeMoved.push(id);
    else this.toBeMoved.splice(i, 1);
    if (!this.inDeleteBulk) {
      this.SyncSelectedLineItem(this.toBeMoved);
    }
  },
        ReformatRows(){
            const self = this 
            if(self.rowDatas.length==0){
                return []
            }
            self.dataReady = false

            self.LineItemData = []
            function TotalBasedOnTheSelectedColumn(item)
            {
                for(let x =0 ; x < BoQColumnList.length; x++)
                {
                    const selectedColumnDataIndex = BoQColumnList[x].lineItemIndex
                    let data = self.totalObj[selectedColumnDataIndex]
                    if(!data)
                    {
                        self.totalObj[selectedColumnDataIndex] = item[selectedColumnDataIndex]
                    }
                    else
                    {
                        self.totalObj[selectedColumnDataIndex] += item[selectedColumnDataIndex]
                    }
                }
            }
      
            let lineItemSubCount = 1
            self.rowDatas.map((u)=>{
                const supplyAndInstallCombine = u.supplyAndInstall ? u.supplyAndInstall : (u.costRate || 0) + (u.installRate || 0)
                const  supplyAndInstallTotal = supplyAndInstallCombine * u.quantity


                u.label = lineItemSubCount++
                u.bufferCostTotal = u.costTotal - u.costTotalRaw
                u.bufferSellRate = u.sellRate - u.sellRateRaw
                u.bufferSellTotal = u.sellTotal - u.sellTotalRaw
                u.bufferGp = u.gp - u.gpRaw
                u.supplyAndInstallTotal = supplyAndInstallTotal

                TotalBasedOnTheSelectedColumn(u)
             
                self.LineItemData.push(u)
                return u
            })
            self.dataReady =true
        },
        PassData(){
            this.GetSequence(this.LineItemData)
        },
        onEndDrag(e){
            if(e.newIndex!=e.oldIndex){
                this.GetChanges()
            }
        },
        ReformatNumber : ReformatNumber,
        OpenEditOnDblClick(key){
            this.$refs.ModalUpdateLineItemBtn[key].click()
        },
        OnClickTr(data){
            const self = this
            
            const getIndex=  self.selectedLineItems.findIndex(u=>u._id==data._id)
            if(getIndex==-1){
                self.selectedLineItems.push({
                    _id : data._id,
                    costCode : data.costCode,
                    name : data.name
                })
                self.selectedLineItemsId.push(data._id)
            }else{
                self.selectedLineItems.splice(getIndex,1)
                self.selectedLineItemsId.splice(getIndex,1)
            }


            self.updateSelected(self.selectedLineItems)
        },
        OpenDelete(id){
            const self = this

            let deleteFunc = GetBoqItemDelete
            if(self.DeleteItemFunc){
                deleteFunc = self.DeleteItemFunc
            }

            const swalTitle = self.$i18n.t('Delete')

            self.$swal({
                title: swalTitle,
                text : self.$i18n.t('Bill of Quantity Module.Remove Item from Bill of Quantities') + '?',
                showCancelButton: true,
                icon: 'warning',
                showLoaderOnConfirm: true,
                allowOutsideClick: () => !self.$swal.isLoading(),
                preConfirm: () => deleteFunc(id)
            }).then((res)=>{
                if(res.isConfirmed){
                    if(res.value=='OK'){
                        self.$swal(swalTitle, self.$i18n.t('Deleted Successfully'), 'success')
                        self.reloadData()
                    }else{
                        self.$swal(swalTitle,res.value,'warning')
                    }
                }
            })
        },
    }

}
</script>
<style scoped>
    .sticky-top{
        position : sticky;
        top:0;
        z-index: 100;
    }
    .sticky-left{
        position : sticky;
        left:0;
        z-index: 50;
    }
    .sticky-right{
        position : sticky;
        right:0;
        z-index: 50;
    }
    .boq-col-select{
        left: 0;
        width: 44px;
        min-width: 44px;
        max-width: 44px;
    }
    .boq-col-serial{
        left: 44px;
        width: 60px;
        min-width: 60px;
        max-width: 60px;
    }
    .boq-col-description{
        left: 104px;
        width: 360px;
        min-width: 360px;
        max-width: 360px;
    }
    .boq-line-items-table--published .boq-col-serial{
        left: 0;
    }
    .boq-line-items-table--published .boq-col-description{
        left: 60px;
    }
    thead .boq-col-select,
    thead .boq-col-serial,
    thead .boq-col-description{
        z-index: 120;
    }
    tfoot .boq-col-select,
    tfoot .boq-col-serial,
    tfoot .boq-col-description{
        z-index: 70;
    }
    .line-item-100{
        min-width: 90px;
    }
    .cursor-move{
        cursor:  move;
    }
</style>
